import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM23.285 11.715h-11.57c-.623 0-1.165.344-1.447.852.088.023.173.06.252.113l6.98 4.653 6.98-4.653a.823.823 0 0 1 .252-.113 1.652 1.652 0 0 0-1.447-.852Zm-13.223 9.917v-7.271l6.98 4.653c.277.185.639.185.916 0l6.98-4.653v7.271c0 .913-.74 1.653-1.653 1.653h-11.57c-.913 0-1.653-.74-1.653-1.653Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgEmail;